import { STORAGE_KEY } from "../constants";
import type { CapturedLead } from "../types";

const isBrowser = (): boolean =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const saveLead = (lead: CapturedLead): void => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(lead));
  } catch (error) {
    console.error("Failed to save lead:", error);
  }
};

const isCapturedLead = (v: unknown): v is CapturedLead => {
  if (!v || typeof v !== "object") return false;
  const o = v as Record<string, unknown>;
  return (
    typeof o.email === "string" &&
    typeof o.company_name === "string" &&
    typeof o.company_domain === "string" &&
    (o.job_id === null || typeof o.job_id === "string") &&
    typeof o.timestamp === "string"
  );
};

export const loadLead = (): CapturedLead | null => {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isCapturedLead(parsed) ? parsed : null;
  } catch (error) {
    console.error("Failed to load lead:", error);
    return null;
  }
};

export const clearLead = (): void => {
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear lead:", error);
  }
};
